/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SftpSettingsDTO
 */
export interface SftpSettingsDTO {
    /**
     * 
     * @type {string}
     * @memberof SftpSettingsDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SftpSettingsDTO
     */
    ftpHostName?: string;
    /**
     * 
     * @type {number}
     * @memberof SftpSettingsDTO
     */
    ftpPort?: number;
    /**
     * 
     * @type {string}
     * @memberof SftpSettingsDTO
     */
    ftpUserName?: string;
    /**
     * 
     * @type {string}
     * @memberof SftpSettingsDTO
     */
    ftpPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof SftpSettingsDTO
     */
    ftpDirectoryPath?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SftpSettingsDTO
     */
    ftpUsePassiveMode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SftpSettingsDTO
     */
    ftpUseSslMode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SftpSettingsDTO
     */
    ftpUseSftp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SftpSettingsDTO
     */
    ftpZipFiles?: boolean;
}

export function SftpSettingsDTOFromJSON(json: any): SftpSettingsDTO {
    return SftpSettingsDTOFromJSONTyped(json, false);
}

export function SftpSettingsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SftpSettingsDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'ftpHostName': !exists(json, 'ftpHostName') ? undefined : json['ftpHostName'],
        'ftpPort': !exists(json, 'ftpPort') ? undefined : json['ftpPort'],
        'ftpUserName': !exists(json, 'ftpUserName') ? undefined : json['ftpUserName'],
        'ftpPassword': !exists(json, 'ftpPassword') ? undefined : json['ftpPassword'],
        'ftpDirectoryPath': !exists(json, 'ftpDirectoryPath') ? undefined : json['ftpDirectoryPath'],
        'ftpUsePassiveMode': !exists(json, 'ftpUsePassiveMode') ? undefined : json['ftpUsePassiveMode'],
        'ftpUseSslMode': !exists(json, 'ftpUseSslMode') ? undefined : json['ftpUseSslMode'],
        'ftpUseSftp': !exists(json, 'ftpUseSftp') ? undefined : json['ftpUseSftp'],
        'ftpZipFiles': !exists(json, 'ftpZipFiles') ? undefined : json['ftpZipFiles'],
    };
}

export function SftpSettingsDTOToJSON(value?: SftpSettingsDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'ftpHostName': value.ftpHostName,
        'ftpPort': value.ftpPort,
        'ftpUserName': value.ftpUserName,
        'ftpPassword': value.ftpPassword,
        'ftpDirectoryPath': value.ftpDirectoryPath,
        'ftpUsePassiveMode': value.ftpUsePassiveMode,
        'ftpUseSslMode': value.ftpUseSslMode,
        'ftpUseSftp': value.ftpUseSftp,
        'ftpZipFiles': value.ftpZipFiles,
    };
}

